import styled from "styled-components";

import theme from "../../../../theme";

export interface IWrapperProps {
  horizontalPadding?: number;
}

const VerticalWrapper = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  color: ${theme.colors.brown};
  padding: 0
    ${({ horizontalPadding }: IWrapperProps): string =>
      `${horizontalPadding || 0}px`};

  flex-direction: column;
  margin-top: 0;
  font-size: 15px;
`;

export default VerticalWrapper;
